/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import classNames from 'classnames';
import HotelCardGalleryOverlay from './components/HotelCardGalleryOverlay';
import HotelCardFeatures from './components/HotelCardFeatures';
import HotelCardPrice from './components/HotelCardPrice';
import HotelCardLabels from './components/HotelCardLabels';
import type { MapHotelCardProps } from './types';
import { HOTEL_CARD_HOTEL_INFO, HOTEL_CARD_TEST_ID } from './constants';
import styles from './mapHotelCardSmall.module.css';

const MapHotelCardSmall: React.FC<MapHotelCardProps> = (props) => {
  const {
    id,
    images,
    bonusCount,
    currencyCode,
    hotelPageVisited,
    stars,
    hotelName,
    hotelLocation,
    rating,
    cashbackIdentifier,
    customCashbackIconURL,
    customCashbackText,
    customCashbackTooltipText,
    features,
    instantConfirm,
    price,
    innerLabels,
    isHotelOnly,
    availability,
    hotelPageHref,
    openInCurrentTab,
    className,
  } = props;

  return (
    <div
      data-testid={HOTEL_CARD_TEST_ID}
      className={classNames(styles.cardContainer, className)}
    >
      <HotelCardGalleryOverlay
        id={id}
        images={images}
        isMobile
        bonusCount={bonusCount}
        currencyCode={currencyCode}
        hotelPageVisited={hotelPageVisited}
        stars={stars}
        hotelName={hotelName}
        hotelLocation={hotelLocation}
        rating={rating}
        cashbackIdentifier={cashbackIdentifier}
        customCashbackIconURL={customCashbackIconURL}
        customCashbackText={customCashbackText}
        customCashbackTooltipText={customCashbackTooltipText}
        isMapCard
        hotelPageHref={hotelPageHref}
        openInCurrentTab={openInCurrentTab}
      />
      <a
        data-testid={HOTEL_CARD_HOTEL_INFO}
        href={hotelPageHref}
        target={openInCurrentTab ? '_self' : '_blank'}
        className={styles.hotelInfo}
      >
        <HotelCardFeatures isMobile features={features} />
        <HotelCardLabels isMobile labels={innerLabels} />
        <HotelCardPrice
          availability={availability}
          instantConfirm={instantConfirm}
          isMobile
          isFlexDates={false}
          isMapCard
          price={price}
          currencyCode={currencyCode}
          isHotelOnly={isHotelOnly}
        />
      </a>
    </div>
  );
};

export default MapHotelCardSmall;
